module.exports = __webpack_public_path__ + "b6cffcca60f96c5800c8470369ece3f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/beach-bungalow.png
// module id = 562
// module chunks = 0